import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  QuotaCollectionConfig,
  type QuotaCollection,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
export const QuotaCollectionItem: RelationFieldProps<QuotaCollection> = {
  nested: getRelationFieldNames(QuotaCollectionConfig),
  filters: [],
  renderItem: (item, isRelationField) => ({
    title: item?.name,
    descriptionItems: (
      <div
        className={cn(
          'flex items-center',
          isRelationField && 'w-full justify-between'
        )}
      >
        <span className='font-medium'>{item.idNumber}</span>
      </div>
    ),
  }),
};
